import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL;

function dashBoardLocal() {
    return axios.get(`${url}/localization_menu`)
        .then(response => {
            return {
                dashBoardLocal: response.data,
                meta: response.data.meta
            };
        });
}

function pageLocal(params) {
    const payload = JSON.stringify(params);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/localization_page`,payload,options)
        .then(response => {
            return response.data;
        });
}
function pagesLocal(params) {
    const payload = JSON.stringify(params);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/localization_pages`,payload,options)
        .then(response => {
            return response.data;
        });
}

function getLanguages() {
    return axios.get(`${url}/get_languages`)
        .then(response => {
            return {
                getLanguages: response.data,
                meta: response.data.meta
            };
        });
}

function updateLanguages(params) {
    const payload = JSON.stringify(params);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.put(`${url}/update_localization_user`,payload,options)
        .then(response => {
            return response.data;
        });
}
function getAllPageTranslate() {
    return axios.get(`${url}/all_bind_page`)
        .then(response => {
            return {
                getAllPageTranslate: response.data,
                meta: response.data.meta
            };
        });
}

function getListTranslate(params) {
    let requestUrl = `${url}/list_translate?`;
    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            requestUrl += `${key}=${params[key]}&`;
        }
    }
    return axios.get(requestUrl)
        .then(response => {
            return {
                getListTranslate: response.data,
                meta: response.data.meta
            };
        });
}

function getTranslate(params) {
    let requestUrl = `${url}/get_translate/` + params;
    return axios.get(requestUrl)
        .then(response => {
            return {
                getTranslate: response.data,
                meta: response.data.meta
            };
        });
}

function listTranslatePage(params) {
    const payload = JSON.stringify(params);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/list_translate_page`,payload,options)
        .then(response => {
            return response.data;
        });
}

function updateTranslatePage(params) {
    const payload = JSON.stringify(params);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/update_translate_page`,payload,options)
        .then(response => {
            return response.data;
        });
}

function createLanguage(params) {
    const payload = JSON.stringify(params);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/create_language`,payload,options)
        .then(response => {
            return response.data;
        });
}

export default {
    dashBoardLocal,
    pageLocal,
    pagesLocal,
    getLanguages,
    updateLanguages,
    getAllPageTranslate,
    listTranslatePage,
    updateTranslatePage,
    createLanguage,
    getListTranslate,
    getTranslate

};